import React, { Component } from "react";
import { LoginService } from "../Common/_services/login.service";

let _expiresAt;
export default class Authentication {
    roleScopes = [];
    authResult;
    // userInformation;

    constructor(history) {
        this.history = history;
        this.authResult = localStorage.getItem("authResult") ? JSON.parse(localStorage.getItem("authResult")) : "";
        this.initialAuthDetails = {
            domain: process.env.REACT_APP_AUTH_DOMAIN,
            clientID: process.env.REACT_APP_AUTH_CLIENTID,
            redirectURL: process.env.REACT_APP_AUTH_REDIRECTURL,
            acrValue: process.env.REACT_APP_AUTH_ACRVALUE,
            responseType: process.env.REACT_APP_AUTH_RESPONSETYPE,
            state: process.env.REACT_APP_AUTH_STATE,
            scope: process.env.REACT_APP_AUTH_SCOPE
        }
        this.isScopesLoaded = false;
    }

    login = () => {
        // Redirect to GAS_OIDC screen by passing the initial parameters 

        // location.href = `https://sso.i.daimler.com/as/authorization.oauth2? 
        // response_type=${initialAuthDetails.responseType} &
        // client_id=${initialAuthDetails.clientID} &
        // redirect_uri=${initialAuthDetails.redirectURL} & 
        // scope=${initialAuthDetails.scope}&
        // acr_values=${initialAuthDetails.acrValue} & 
        // state=${initialAuthDetails.state}`

        localStorage.setItem("redirect_on_login", JSON.stringify(this.history));
        //Directly navigate to callback till GAS_OIDC approvals
        let url = `/callback?code=1234567890&state=login`;
        this.history.push(url);
    }

    async handleAuthentication(authResult) {
        if (authResult && authResult.idToken) {
            this.authResult = authResult;
            // this.setSession(authResult);
            //once the token is received , redirect to home screen or to standby screen
            const redirectLocation = localStorage.getItem("redirect_on_login") ? JSON.parse(localStorage.getItem("redirect_on_login")) : "/";
            // trigger roles API to get the roles - starts
            // storing user id after OIDC
            localStorage.setItem("userId", authResult.userId);
            try {
                let response = await LoginService.getUserDetailsById(authResult.userId);
                this.setRoleInfo(response);
                localStorage.setItem("isLoginSucess", true);
                // this.userInformation = response;
                // roles implementation - ends
                this.history.push("/dashboard");
                return response;
            } catch (error) {
                console.log(error);
                this.isScopesLoaded = true;
                // this.userInformation = sampleArray;
                // roles implementation - ends
                this.history.push("/unauthorized");
            }

        } else {
            //error handle
            this.history.push("/");
        }
        localStorage.removeItem("redirect_on_login");
    }

    isAuthenticated() {
        return this.authResult ? true : false;
    }

    setSession(authResult) {
        // console.log(authResult);
        _expiresAt = authResult.expiresIn * 1000 + new Date().getTime();
        localStorage.setItem("authResult", JSON.stringify(authResult));
        this.authResult = authResult;

        // let delay = _expiresAt - Date.now();
        // if (delay < 0) {
        //     setTimeout(() => this.renewToken(), delay);
        // }
    }

    async renewToken() {
        const response = {
            expiresIn: 600,
            scope: "",
            accessToken: "sdflksjfsdoiewroewijrweorjwoojr.sdfodjoifdjfoidsf.wewerewrew324324",
            idToken: "dsfkoeiriewirweosldfmsdkfdsfsdrew.oiwerjwoerjoeofdsokf.23i4234ilklkdflkf",
            userId: localStorage.getItem('userId')
        }

        this.authResult = response;
        this.setSession(this.authResult);
    }

    async getUserDetailsById() {
     
        // const redirectLocation = this.history;
        if (localStorage.getItem('userId')) {
            try {
               
                let response = await LoginService.getUserDetailsById(localStorage.getItem('userId'));
                this.setRoleInfo(response);
                // this.userInformation = response;
                // roles implementation - ends
                // this.history.push(redirectLocation);
                return response;
            } catch (error) {
                console.log(error);
               // alert()
                this.isScopesLoaded = true;
                if (localStorage.getItem('userId')) {
                    this.history.push("/unauthorized");
                }
            }
        }
    }

    setRoleInfo(roles) {
       
        // from callback route
        this.isScopesLoaded = true;
        localStorage.setItem("roleName", roles.roleName);
        let whiteSpaceRemovedString = roles.urlAllowed.replace(/\s+/g, '');
        this.roleScopes = whiteSpaceRemovedString.split(',');
    }

    userHasScopes(scopesFromPrivateRoute) {
        // console.log(">>>>> rolescopes from userHasscope method", this.roleScopes);
        let grantedScopes = this.roleScopes;
        return scopesFromPrivateRoute.every((routeScope) => grantedScopes.includes(routeScope));
    }
    logout = () => {
        localStorage.clear();
        this.roleScopes = [];
        this.authResult = "";
        this.isScopesLoaded = false;
       
        window.location.href=process.env.REACT_APP_AUTH_LOGOUT
    }
}